// components/adBooth.js

"use client"

import { Col, Row } from 'antd'
import Image from 'next/image'
import { isNull } from '@/lib/utils';

export default function AdBooth({ adBooth }) {

    if (isNull(adBooth) || adBooth.length <= 0) {
        return null;
    }

    const handleClickBooth = (item) => {
        if (isNull(item.url)) {
            return;
        }
        window.open(item.url, '_blank');
    };


    return (

        <div className='ad_booth'>
            <div className='box_warp'>
                <Row gutter={[16, 16]}>
                    {adBooth.map((item, index) => (
                        <Col key={index} span={12} className='booth_item' onClick={() => handleClickBooth(item)}>
                            <div className='booth_item_img'>
                                <Image src={item.pic} alt='ad_booth' fill />
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>

    );
}